import React from 'react';
import { styled } from '@mui/material';
import Button from '../Button';
import SplitButton from '../SplitButton';
import ActionMenu from './ActionMenu';
import StandardTooltip from '../StandardTooltip';
export const WrappedButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'hidden' && prop !== 'iconOnly'
})(_ref => {
  let {
    hidden,
    iconOnly
  } = _ref;
  if (iconOnly == true) {
    return {
      visibility: hidden ? 'hidden' : undefined,
      whiteSpace: 'nowrap',
      marginLeft: '5px',
      marginRight: '5px',
      minWidth: 'unset',
      "& .MuiButton-startIcon": {
        marginRight: "0px"
      }
    };
  }
  return {
    visibility: hidden ? 'hidden' : undefined,
    whiteSpace: 'nowrap',
    marginLeft: '5px',
    marginRight: '5px',
    minWidth: 'unset'
  };
});
export const PrimaryActionButton = _ref2 => {
  let {
    action,
    data,
    hidden,
    ariaLabelDropdown = 'dropdown',
    disabled = false
  } = _ref2;
  const handleClick = event => {
    if (typeof action.onClick === 'function') {
      action.onClick(event, data);
    }
  };
  const text = Boolean(action.icon) && action.prefferPriorityIconOnly == true ? null : action.label;
  const tooltip = action.prefferPriorityIconOnly == true && Boolean(action.icon) ? "".concat(action.label, ": ").concat(action.tooltip) : action.tooltip;
  if (action.subActions && action.subActions.length > 0) {
    return /*#__PURE__*/React.createElement(SplitButton, {
      id: action.id,
      color: action.color || 'primary',
      variant: action.variant || 'outlined',
      text: text,
      icon: action.icon,
      onClick: handleClick,
      href: action.href,
      hidden: hidden,
      ariaLabelDropdown: ariaLabelDropdown,
      disabled: disabled || action.disabled,
      DropdownMenu: _ref3 => {
        let {
          onCloseMenu
        } = _ref3;
        return /*#__PURE__*/React.createElement(ActionMenu, {
          actions: action.subActions,
          disabled: disabled,
          data: data,
          showSubActionDividers: true,
          onCloseMenu: onCloseMenu
        });
      }
    });
  }
  return /*#__PURE__*/React.createElement(StandardTooltip, {
    title: tooltip,
    enterDelay: 1000,
    leaveDelay: 0
  }, /*#__PURE__*/React.createElement(WrappedButton, {
    id: action.id,
    color: action.color || 'secondary',
    variant: action.variant || 'outlined',
    onClick: handleClick,
    href: action.href,
    startIcon: action.icon,
    disabled: disabled || action.disabled,
    children: text,
    hidden: hidden,
    iconOnly: text === null
  }));
};
export default PrimaryActionButton;